/* Progressive 3D body motion. Base content is always visible; no media or form writes. */
(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { api.mount(window); }, { once: true });
    } else api.mount(window);
  }
})(function () {
  'use strict';
  var REVEALS = [
    '[data-portrait-reveal]', '.cg-home .cg-card', '.s3-collection .s3-card', '.ps-signature-invite__copy',
    '.making-guide .mg-hero__copy', '.making-guide .mg-hero__photo',
    '.making-guide .cg-steps > li', '.making-guide .mg-prep > div',
    '.making-guide .mg-photo-list > div', '.making-guide .mg-proof__photo',
    '.making-guide .mg-proof__copy', '.making-guide .mg-next',
    '.studio-story-hero__copy', '.studio-story-hero__visual', '.studio-story-belief',
    '.studio-story-section-head', '.studio-story-gallery > figure',
    '.studio-story-values__intro', '.studio-story-standard',
    '.studio-story-assurance', '.studio-story-close'
  ];
  var HERO = ['.cg-hero__art', '.cg-hero__copy h1', '.cg-hero__copy > .cg-button'];
  var SCOPE = '[data-world-panel="3d"], [data-world-page="3d"], [data-gallery-design="3"], .s3-product, .s3-collection, .studio-story';

  function mount(win) {
    if (win.__vpPortraitMotion && win.__vpPortraitMotion.refresh) {
      win.__vpPortraitMotion.refresh();
      return win.__vpPortraitMotion;
    }
    var doc = win.document, main = doc.querySelector('main');
    if (!main) return null;
    var reduced = win.matchMedia ? win.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var mobile = win.matchMedia ? win.matchMedia('(max-width: 760px)') : { matches: false };
    var records = [], byNode = new Map(), galleryImages = new Set(), listeners = [];
    var running = new Map(), observer, worldObserver, floatRecord = null;
    var disposed = false, suspended = false, transitioning = false;

    function listen(target, type, handler) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(type, handler);
      listeners.push(function () { target.removeEventListener(type, handler); });
    }
    function listenMedia(query) {
      if (query.addEventListener) listen(query, 'change', sync);
      else if (query.addListener) {
        query.addListener(sync);
        listeners.push(function () { query.removeListener(sync); });
      }
    }
    function inScope(node) {
      return main.contains(node) && !!node.closest(SCOPE) &&
        !node.closest('[data-world-panel="brick"], [data-world-page="brick"], form, dialog');
    }
    function visible(node) {
      if (!inScope(node) || node.hidden || !node.getClientRects().length) return false;
      var box = node.getBoundingClientRect();
      return box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < win.innerHeight &&
        box.right > 0 && box.left < win.innerWidth;
    }
    function active() {
      return !disposed && !suspended && !transitioning && !doc.hidden &&
        doc.documentElement.dataset.world === '3d' && !reduced.matches;
    }
    function finish(node, animation) {
      if (running.get(node) !== animation) return;
      running.delete(node);
      node.removeAttribute('data-portrait-motion-running');
    }
    function cancel(node) {
      var animation = running.get(node);
      if (!animation) return;
      animation.onfinish = animation.oncancel = null;
      animation.cancel();
      finish(node, animation);
    }
    function animateOnce(node, frames, timing) {
      if (!active() || !inScope(node) || !visible(node) || !node.animate) return;
      // Never move an element the keyboard user is currently interacting with.
      if (doc.activeElement && node.contains(doc.activeElement)) return;
      cancel(node);
      var animation = node.animate(frames, timing);
      running.set(node, animation);
      node.setAttribute('data-portrait-motion-running', '');
      animation.onfinish = animation.oncancel = function () { finish(node, animation); };
    }
    function reveal(record) {
      if (record.done || !record.visible || !active() || !visible(record.node)) return;
      if (record.kind === 'hero-art' && record.node.tagName === 'IMG' &&
          (!record.node.complete || !record.node.naturalWidth)) return;
      record.done = true;
      var compact = mobile.matches;
      animateOnce(record.node, [
        { opacity: record.kind === 'hero-copy' ? 1 : .72, translate: '0 ' + (compact ? 4 : 12) + 'px' },
        { opacity: 1, translate: '0 0' }
      ], {
        duration: compact ? 230 : 430,
        delay: compact ? Math.min(record.delay, 45) : record.delay,
        easing: 'cubic-bezier(.2,.7,.2,1)'
      });
      if (observer) observer.unobserve(record.node);
    }
    function cancelFloat() {
      if (!floatRecord || !floatRecord.animation) return;
      floatRecord.animation.cancel();
      floatRecord.animation = null;
      floatRecord.node.removeAttribute('data-portrait-motion-floating');
    }
    function syncFloat() {
      if (!floatRecord) return;
      var node = floatRecord.node;
      if (reduced.matches || mobile.matches || disposed) { cancelFloat(); return; }
      var canPlay = active() && floatRecord.visible && visible(node) &&
        node.complete && node.naturalWidth > 0 && !!node.animate;
      if (!canPlay) {
        if (floatRecord.animation) floatRecord.animation.pause();
        return;
      }
      if (!floatRecord.animation) {
        // Only an explicitly opted-in, independent product cutout can float.
        floatRecord.animation = node.animate([
          { translate: '0 0' }, { translate: '0 -5px' }, { translate: '0 0' }
        ], { duration: 5400, iterations: Infinity, easing: 'ease-in-out' });
        node.setAttribute('data-portrait-motion-floating', '');
      } else floatRecord.animation.play();
    }
    function sync() {
      if (disposed) return;
      if (!active()) {
        Array.from(running.keys()).forEach(cancel);
      } else {
        records.forEach(function (record) {
          if (record.kind !== 'float') reveal(record);
        });
      }
      syncFloat();
    }
    function observe(record) {
      record.visible = visible(record.node);
      if (observer && (!record.done || record.kind === 'float')) observer.observe(record.node);
    }
    function register(node, kind, delay) {
      if (!inScope(node) || byNode.has(node)) return;
      var record = { node: node, kind: kind, delay: delay || 0, done: false, visible: false };
      byNode.set(node, record); records.push(record); observe(record);
      if (kind === 'hero-art' && node.tagName === 'IMG') listen(node, 'load', recheck);
      return record;
    }
    function refresh() {
      if (disposed) return;
      HERO.forEach(function (selector, index) {
        main.querySelectorAll(selector).forEach(function (node) {
          register(node, index ? 'hero-copy' : 'hero-art', index * 75);
        });
      });
      REVEALS.forEach(function (selector) {
        main.querySelectorAll(selector).forEach(function (node, index) {
          register(node, 'reveal', Math.min(index % 4, 3) * 45);
        });
      });
      main.querySelectorAll('[data-portrait-gallery] [data-edition-image]').forEach(function (image) {
        if (!inScope(image) || galleryImages.has(image)) return;
        galleryImages.add(image);
        listen(image, 'load', function () {
          if (!image.naturalWidth) return;
          animateOnce(image, [{ opacity: .72 }, { opacity: 1 }],
            { duration: mobile.matches ? 160 : 260, easing: 'ease-out' });
        });
      });
      if (!floatRecord) {
        var candidates = Array.from(main.querySelectorAll('img[data-portrait-float]'));
        var candidate = candidates.find(inScope);
        if (candidate) {
          floatRecord = register(candidate, 'float');
          if (floatRecord) listen(candidate, 'load', syncFloat);
        }
      }
      records.forEach(observe);
      sync();
    }
    if (win.IntersectionObserver) {
      observer = new win.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var record = byNode.get(entry.target);
          if (!record) return;
          record.visible = entry.isIntersecting && entry.intersectionRatio > 0;
          if (record.kind === 'float') syncFloat(); else reveal(record);
        });
      }, { threshold: .1 });
    }
    function recheck() {
      if (disposed || suspended) return;
      records.forEach(function (record) { record.visible = visible(record.node); });
      sync();
    }
    listenMedia(reduced); listenMedia(mobile);
    listen(doc, 'visibilitychange', recheck);
    listen(win, 'vp:worldchange', recheck);
    listen(win, 'vp:entryready', function () { transitioning = false; refresh(); });
    listen(win, 'vp:transitionstart', function () { transitioning = true; sync(); });
    listen(win, 'vp:transitionend', function () { transitioning = false; refresh(); });
    listen(win, 'resize', recheck);
    // Without IntersectionObserver, keep offscreen content static and use bounded events.
    if (!observer) listen(win, 'scroll', recheck);
    listen(doc, 'shopify:section:load', refresh);
    listen(win, 'pagehide', function (event) {
      if (!event.persisted) { controller.dispose(); return; }
      suspended = true;
      if (observer) observer.disconnect();
      sync();
    });
    listen(win, 'pageshow', function () {
      suspended = false; transitioning = false; refresh();
    });
    if (win.MutationObserver) {
      worldObserver = new win.MutationObserver(recheck);
      worldObserver.observe(doc.documentElement, { attributes: true, attributeFilter: ['data-world'] });
    }
    var controller = {
      refresh: refresh,
      dispose: function () {
        if (disposed) return;
        disposed = true;
        Array.from(running.keys()).forEach(cancel);
        cancelFloat();
        if (observer) observer.disconnect();
        if (worldObserver) worldObserver.disconnect();
        listeners.forEach(function (remove) { remove(); });
        listeners = [];
        if (win.__vpPortraitMotion === controller) delete win.__vpPortraitMotion;
      }
    };
    win.__vpPortraitMotion = controller;
    refresh();
    return controller;
  }
  return { mount: mount, revealSelectors: REVEALS.slice(), heroSelectors: HERO.slice() };
});
